<cdx-slotted-modal (close)="close()" [mobileFullHeight]="true">
	<h1 i18n="@@storeSelectionTitle" modal-header>Select Pick up store</h1>
	<fulfilment-pickup-store-selection modal-content (storeSelected)="close()"></fulfilment-pickup-store-selection>
</cdx-slotted-modal>
